
import { DATA_SOURCES_METADATA } from '@/constants';
import { BotMixin } from '@/mixins/BotMixin';
import { ServiceMetadata } from '@/types';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bot-data-sources-list-card',
})
export default class BotDataSourcesListCard extends mixins(BotMixin) {
  get dataSourcesMetadata(): ServiceMetadata[] {
    return DATA_SOURCES_METADATA;
  }
}
